/* eslint-disable @typescript-eslint/no-unused-vars */

/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useCallback, useRef, forwardRef, useImperativeHandle } from "react";
import { usePermission } from "../../hooks/usePermissionTabs";
import ButtonStyled from "../../components/common/ButtonStyled";

import {

  IconBarcode,

  IconChevronLeft,

  IconCloudUpload,

  IconEdit,

  IconPlus,

  IconTrash,

  IconPlayerPlay,

  IconX,

  IconDatabase,

  IconFileText,

  IconTag,

  IconBuilding,

  IconRuler,

  IconShieldCheck,

  IconStack,

} from "@tabler/icons-react";

import Input from "../../components/Input";

import SelectInput from "../../components/Select";

import TextareaField from "../../components/common/TextareaField";

import NewinputField from "../../components/NewInput";

import NewSelectInput from "../../components/NewSelectInput";

import { useNavigate, useParams } from "react-router-dom";

import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";

import type {

  Control,

  UseFormRegister,

  UseFormWatch,

  UseFormSetValue,

  FieldErrors,

  UseFormClearErrors,

} from "react-hook-form";

import {

  useItemProductCreateMutation,

  useItemsUpdateMutation,

  useProductSubCategoriesListData,

  useProductCategoryAllListData,

  useFetchProductItemsViewData,

} from "../../apis/productApis";

import toast from "react-hot-toast";

import { useDropzone } from "react-dropzone";

import ToggleButton from "../../components/ToggleButton";



type ItemForm = {

  itemName: string;

  categoryId: string;

  subCategory?: string;

  sku?: string;

  // storageType: string;

  // capacity: string;

  // minimumQuantity: string;

  length: number | null;

  width: number | null;

  height: number | null;

  weight: number;

  commodity: string;

  importCommodity: string;

  dangerousGoods: boolean;

  hsCode: string;

  shortDescription: string;

  longDescription: string;

  itemInfo: Record<string, any>;

  tags: string[];

  variants: Array<{

    name: string;

    optionValue: string;

    price: string;

    sku?: string;

    image?: File | null;

    status?: string;

  }>;

  storage: Array<{

    type: string;

    capacity: string;

    minimumQuantity: string | number;

  }>;

  configOptions: string[];

  termsAndConditions: string;

  publishedOnApp: boolean;

  price1: number | null;

  price2: number | null;

  discount: number | null;

  minimumOrder: number | null;

  expiryBlock: boolean;

  variantsEnabled: boolean;

  expiryDays: number | null;

};



const storageTypes = [

  { id: 1, value: "BINS", text: "BINS" },

  { id: 2, value: "PALLETS", text: "PALLETS" },

];



const dangerousGoods = [

  { id: 1, value: "YES", text: "YES" },

  { id: 2, value: "NO", text: "NO" },

];



type FileWithPreview = {

  file: File | string;

  preview: string;

  isExisting?: boolean;

  type: "image" | "video";

  thumbnail?: string | null;

};



type MediaUploaderProps = {

  media: FileWithPreview[];

  onMediaChange: (media: FileWithPreview[]) => void;

  maxItems?: number;

  isEditing: boolean;

  inline?: boolean;

};



const generateVideoThumbnail = (source: File | string): Promise<string> => {

  return new Promise((resolve) => {

    const video = document.createElement("video");



    // Senior Dev Fix: Set crossOrigin for URLs to avoid Tainted Canvas error

    if (typeof source === "string") {

      video.crossOrigin = "anonymous";

      video.src = source;

    } else {

      video.src = URL.createObjectURL(source);

    }



    video.preload = "metadata";

    video.muted = true;

    video.playsInline = true;



    video.onloadeddata = () => {

      // Seek to 1 second to get a meaningful frame instead of a black start

      video.currentTime = 1;

    };



    video.onseeked = () => {

      try {

        const canvas = document.createElement("canvas");

        canvas.width = video.videoWidth;

        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");



        // Draw the current video frame to the canvas

        ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);



        // Export the canvas content

        const dataUri = canvas.toDataURL("image/jpeg");



        // Memory cleanup for local files

        if (source instanceof File) URL.revokeObjectURL(video.src);



        resolve(dataUri);

      } catch (error) {

        console.error("Canvas Export Failed (CORS issue):", error);

        // Fallback: return the original source string if canvas fails

        resolve(typeof source === "string" ? source : "");

      }

    };



    video.onerror = () => {

      if (source instanceof File) URL.revokeObjectURL(video.src);

      resolve("");

    };

  });

};



export const MediaUploader: React.FC<MediaUploaderProps> = ({

  media,

  onMediaChange,

  isEditing,

  inline = false,

}) => {

  const inputRef = useRef<HTMLInputElement>(null);



  const MAX_IMAGES = 3;

  const MAX_VIDEOS = 1;



  useEffect(() => {

    return () => {

      media.forEach((item) => {

        if (item.file instanceof File) URL.revokeObjectURL(item.preview);

      });

    };

  }, []);



  const onDropFiles = useCallback(

    async (acceptedFiles: File[]) => {

      if (!isEditing) return;



      const currentImageCount = media.filter((m) => m.type === "image").length;

      const currentVideoCount = media.filter((m) => m.type === "video").length;



      let imagesToProcess: File[] = [];

      let videosToProcess: File[] = [];



      acceptedFiles.forEach((file) => {

        const isVideo = file.type.startsWith("video/");

        if (isVideo) {

          if (currentVideoCount + videosToProcess.length < MAX_VIDEOS) {

            videosToProcess.push(file);

          } else {

            toast.error("Limit reached: Only 1 video allowed");

          }

        } else {

          if (currentImageCount + imagesToProcess.length < MAX_IMAGES) {

            imagesToProcess.push(file);

          } else {

            toast.error("Limit reached: Maximum 3 images allowed");

          }

        }

      });



      const allFilesToProcess = [...imagesToProcess, ...videosToProcess];



      const processedFiles = await Promise.all(

        allFilesToProcess.map(async (file) => {

          const isVideo = file.type.startsWith("video/");

          let thumbnail = "";

          if (isVideo) thumbnail = await generateVideoThumbnail(file);



          return {

            file,

            preview: URL.createObjectURL(file),

            thumbnail: isVideo ? thumbnail : null,

            type: isVideo ? ("video" as const) : ("image" as const),

          };

        }),

      );



      onMediaChange([...media, ...processedFiles]);

    },

    [media, onMediaChange, isEditing],

  );



  const { getRootProps, getInputProps, isDragActive } = useDropzone({

    onDrop: onDropFiles,

    accept: {

      "image/*": [".png", ".jpg", ".jpeg", ".webp"],

      "video/*": [".mp4", ".webm"],

    },

    disabled: !isEditing,

  });



  const handleClick = () => {

    if (isEditing && inputRef.current) inputRef.current.click();

  };



  const makeHero = (index: number) => {

    if (index === 0 || !isEditing) return;

    const newMedia = [...media];

    const [selectedItem] = newMedia.splice(index, 1);

    newMedia.unshift(selectedItem);

    onMediaChange(newMedia);

  };



  const removeMedia = (index: number) => {

    const item = media[index];

    if (item.file instanceof File) URL.revokeObjectURL(item.preview);

    onMediaChange(media.filter((_, i) => i !== index));

  };


  return (
    <div className="grid grid-cols-2 gap-4">
      <div
        {...getRootProps({
          onDragOver: (e: any) => e.preventDefault(),
          onDrop: (e: any) => {
            if (!isEditing) return;
            e.preventDefault();
            e.stopPropagation();
            const draggedIdx = e.dataTransfer.getData("internal_idx");
            if (draggedIdx !== "") {
              makeHero(parseInt(draggedIdx));
            } else if (
              e.dataTransfer.files &&
              e.dataTransfer.files.length > 0
            ) {
              onDropFiles(Array.from(e.dataTransfer.files));
            }
          },
        })}
        className={`
          relative w-full rounded-2xl border-2 border-dashed
          flex items-center justify-center p-2 transition-all
          ${isDragActive ? "border-amber-400 bg-amber-50/60" : "border-gray-300 bg-gray-50/80 hover:border-amber-300"}
          ${media.length === 0 && isEditing ? "cursor-pointer" : ""}
        `}
        onClick={() => media.length === 0 && handleClick()}
      >
        <input {...getInputProps()} ref={inputRef} />
        {media.length > 0 ? (
          <div className="relative w-full flex items-center justify-center">
            {media[0].type === "video" ? (
              <video
                key={media[0].preview}
                src={media[0].preview}
                controls
                className="w-24 h-24 object-contain rounded-lg shadow-sm"
              />
            ) : (
              <img
                src={media[0].preview}
                alt="Main Preview"
                className="w-24 h-24 object-contain rounded-lg"
              />
            )}
            {isEditing && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  removeMedia(0);
                }}
                className="absolute top-2 right-2 p-1.5 bg-red-500 text-white rounded-full shadow-md hover:bg-red-600 transition-colors z-10"
              >
                <IconTrash size={14} />
              </button>
            )}
            {isEditing && (
              <div className="absolute inset-0 pointer-events-none flex items-end justify-center pb-4 opacity-0 group-hover/hero:opacity-100 transition-opacity">
                <span className="bg-black/60 text-white text-[10px] px-2 py-1 rounded-full backdrop-blur-sm">
                  Drag items below to set as main
                </span>
              </div>
            )}
          </div>
        ) : (
          <div className="flex items-center gap-3 w-full">
            <div className="bg-amber-50 p-3 rounded-2xl">
              <IconCloudUpload size={24} className="text-amber-500" />
            </div>
            <div>
              <p className="text-xs text-gray-500 font-medium">3 Images & 1 Video max</p>
              <p className="text-[11px] text-gray-400">Drag & drop to upload</p>
            </div>
          </div>
        )}
      </div>

      <div className="bg-white rounded-2xl p-2 flex items-center gap-2 overflow-x-auto no-scrollbar shadow-sm border border-gray-200">
        {isEditing &&
          (media.filter((m) => m.type === "image").length < MAX_IMAGES ||
            media.filter((m) => m.type === "video").length < MAX_VIDEOS) && (
            <label className="flex-shrink-0 size-12 rounded-xl border-2 border-dashed border-amber-400 flex items-center justify-center cursor-pointer hover:bg-amber-50 transition-colors">
              <input
                type="file"
                multiple
                accept="image/*,video/*"
                className="hidden"
                onChange={(e) => onDropFiles(Array.from(e.target.files || []))}
              />
              <IconPlus size={18} className="text-amber-500" />
            </label>
          )}

        {media.map((item: any, index: number) => (
          <div
            key={index}
            draggable={isEditing}
            onDragStart={(e) =>
              e.dataTransfer.setData("internal_idx", index.toString())
            }
            onClick={() => makeHero(index)}
            className={`
              relative flex-shrink-0 size-12 rounded-xl border overflow-hidden bg-gray-50 group cursor-pointer transition-all active:scale-95
              ${index === 0 ? "border-amber-500 ring-2 ring-amber-500/30" : "border-gray-200 hover:border-gray-400"}
            `}
          >
            {item.type === "video" ? (
              <div className="relative">
                {item.thumbnail ? (
                  <img
                    src={item.thumbnail}
                    className="object-cover"
                    alt="vid-thumb"
                  />
                ) : (
                  <div className="bg-gray-900 flex items-center justify-center" />
                )}
                <div className="absolute inset-0 flex items-center justify-center bg-black/10">
                  <IconPlayerPlay
                    size={14}
                    className="text-white fill-white shadow-sm"
                  />
                </div>
              </div>
            ) : (
              <img
                src={item.preview}
                className="w-full h-full object-cover"
                alt="thumb"
              />
            )}
            {isEditing && (
              <div
                className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center"
                onClick={(e) => {
                  e.stopPropagation();
                  removeMedia(index);
                }}
              >
                <IconTrash size={12} className="text-white" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};



type HeaderProps = {

  id?: string;

  isEditing: boolean;

  product?: any;

  navigate: (path: string) => void;

  setIsEditing: (v: boolean) => void;

  handleCancelEdit: () => void;

  handleSubmit: () => void;

  creating: boolean;

  updating: boolean;

  inline?: boolean;

  onClose?: () => void;

};



const Header: React.FC<HeaderProps> = ({

  id,

  isEditing,

  product,

  navigate,

  setIsEditing,

  handleCancelEdit,

  handleSubmit,

  creating,

  updating,

  inline,

  onClose,

}) => {
  const { allowed: canUpdateProduct } = usePermission("products", "update");

  if (inline) {
    return (
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 sticky top-0 z-50 select-none bg-white">
        <div>
          <h1 className="text-lg font-bold tracking-tight text-[#212121]">
            {id ? (isEditing ? "Edit Item" : "View Item") : "Add Item"}
          </h1>
        </div>

        <div className="flex items-center gap-2">
          {id && !isEditing ? (
            <>
              {canUpdateProduct && (
                <button
                  onClick={() => setIsEditing(true)}
                  className="p-1.5 rounded-lg border border-[#D2D2D2] text-[#404040] hover:bg-gray-50 transition"
                  title="Edit Item"
                >
                  <IconEdit size={18} stroke={1.5} />
                </button>
              )}
              {onClose && (
                <button
                  onClick={onClose}
                  className="p-1.5 rounded-lg border border-[#D2D2D2] text-[#404040] hover:bg-gray-50 transition"
                >
                  <IconX size={18} />
                </button>
              )}
            </>
          ) : (
            <>
              {((id && canUpdateProduct) || !id) && (
                <ButtonStyled
                  type="button"
                  onClick={handleSubmit}
                  disabled={creating || updating}
                  isPending={creating || updating}
                  variant="outline"
                  value={id ? "Update" : "Save"}
                />
              )}
              {onClose && (
                <button
                  onClick={onClose}
                  className="p-1.5 rounded-lg border border-[#D2D2D2] text-[#404040] hover:bg-gray-50 transition"
                >
                  <IconX size={18} />
                </button>
              )}
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between border-b pb-4">
      <div className="flex items-center space-x-3">
        <button
          onClick={() => navigate("/inventory-management")}
          className="p-1.5 border border-[#D2D2D2] rounded-full hover:bg-gray-50"
        >
          <IconChevronLeft strokeWidth={1.5} size={24} />
        </button>
        <p className="text-base font-medium text-[#212121] tracking-[-0.5px]">
          {id ? "Edit Item" : "Add New Item"}
        </p>
      </div>

      <div className="flex items-center gap-2">
        {id && !isEditing && (
          <>
            {product?.barcode && (
              <a
                href={product.barcode}
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-2 text-base rounded-full bg-[#FBD037] text-[#212121] flex items-center gap-2"
              >
                <IconBarcode />
                <span>Download</span>
              </a>
            )}
            {canUpdateProduct && (
              <button
                onClick={() => setIsEditing(true)}
                className="px-6 py-2 text-base rounded-full bg-[#FBD037] text-[#212121] flex items-center gap-2"
              >
                <IconEdit size={18} />
                Edit
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};



interface ConfirmModalProps {

  isOpen: boolean;

  onClose: () => void;

  onConfirm: () => void;

  title: string;

  message: string;

}



const ConfirmModal: React.FC<ConfirmModalProps> = ({

  isOpen,

  onClose,

  onConfirm,

  title,

  message,

}) => {

  if (!isOpen) return null;



  return (

    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm">

      <div className="bg-white rounded-[24px] p-6 w-full max-w-sm shadow-xl border border-gray-100 animate-in fade-in zoom-in duration-200">

        <h3 className="text-lg font-bold text-gray-900 mb-2">{title}</h3>

        <p className="text-sm text-gray-500 mb-6">{message}</p>

        <div className="flex gap-3">

          <button

            onClick={onClose}

            className="flex-1 py-2.5 rounded-full border border-gray-200 text-gray-700 font-medium hover:bg-gray-50 transition-colors"

          >

            Cancel

          </button>

          <button

            onClick={() => {

              onConfirm();

              onClose();

            }}

            className="flex-1 py-2.5 rounded-full bg-red-500 text-white font-medium hover:bg-red-600 transition-colors shadow-sm"

          >

            Yes, Clear

          </button>

        </div>

      </div>

    </div>

  );

};



const TagInput: React.FC<{

  tags: string[];

  onChange: (tags: string[]) => void;

  isEditing: boolean;

}> = ({ tags, onChange, isEditing }) => {

  const [inputValue, setInputValue] = useState("");



  const handleKeyDown = (e: React.KeyboardEvent) => {

    if (e.key === "Enter" || e.key === ",") {

      e.preventDefault();

      const val = inputValue.trim().replace(/,/g, ""); // Remove commas from the input

      if (val && !tags.includes(val)) {

        onChange([...tags, val]);

        setInputValue("");

      }

    }

  };



  const removeTag = (tagToRemove: string) => {

    onChange(tags.filter((t) => t !== tagToRemove));

  };



  return (

    <div className="space-y-2 col-span-full">

      <label className="text-[10px] font-bold uppercase tracking-wider text-gray-500">

        Product Tags (SEO & Search)

      </label>

      <div

        className={`flex flex-wrap gap-2 p-2 min-h-[45px] rounded-2xl border transition-all ${isEditing

          ? "bg-yellow-50 border-gray-200 focus-within:border-amber-400"

          : "bg-gray-50 border-transparent"

          }`}

      >

        {tags.map((tag) => (

          <span

            key={tag}

            className="flex items-center gap-1 px-3 py-1 bg-amber-100 text-amber-800 text-xs font-semibold rounded-lg border border-amber-200 animate-in zoom-in duration-200"

          >

            {tag}

            {isEditing && (

              <button

                onClick={() => removeTag(tag)}

                className="hover:text-red-600"

              >

                <IconX size={12} />

              </button>

            )}

          </span>

        ))}

        {isEditing && (

          <input

            value={inputValue}

            onChange={(e) => setInputValue(e.target.value)}

            onKeyDown={handleKeyDown}

            placeholder="Type tag and press Enter..."

            className="flex-1 min-w-[120px] outline-none text-sm bg-transparent"

          />

        )}

      </div>

    </div>

  );

};



type IdentificationSectionProps = {
  isEditing: boolean;
  allCategory?: any[];
  subCategories?: any[];
  selectedCategory?: string;
  selectedSubCategory?: string;
  register: UseFormRegister<ItemForm>;
  control: Control<ItemForm>;
  clearErrors: UseFormClearErrors<ItemForm>;
  errors: FieldErrors<ItemForm>;
  watch: UseFormWatch<ItemForm>;
  setValue: UseFormSetValue<ItemForm>;
  setShowVariantWarning?: React.Dispatch<React.SetStateAction<boolean>>;
  inline?: boolean;
};



const IdentificationSection: React.FC<IdentificationSectionProps> = ({
  isEditing,
  allCategory,
  subCategories,
  selectedCategory,
  selectedSubCategory,
  register,
  clearErrors,
  errors,
  watch,
  setValue,
  setShowVariantWarning,
  control,
  inline = false,
}) => {

  const dynamicFields =

    subCategories?.find((sc: any) => sc.id === selectedSubCategory)?.fields || [];



  const formatTitle = (key: string) =>

    key

      .replace(/([A-Z])/g, " $1")

      .replace(/_/g, " ")

      .trim()

      .split(" ")

      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())

      .join(" ");



  return (

    <div className="border border-[#D2D2D2]/70 backdrop-blur-xl rounded-[20px] p-5 bg-gradient-to-b from-white/90 to-white/60 space-y-4 shadow-sm col-span-2 h-full">

      {/* Header: Title */}
      <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3 select-none">
        <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
          <IconBarcode size={16} className="text-[#212121]" stroke={1.5} />
        </div>
        <p className="text-[#212121]/80 uppercase text-sm font-semibold tracking-wide">
          IDENTIFICATION
        </p>
      </div>

      {/* Unified Parent Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-4">

        {/* 1. Category */}

        {isEditing ? (

          <SelectInput

            name="categoryId"

            label="Category"

            placeholder="Select Category"

            selectOptions={

              allCategory?.map((item: any) => ({

                id: item.id,

                value: item.category,

                text: item.category,

              })) || []

            }

            register={register}

            clearErrors={clearErrors}

            validation={{ required: "Category is required" }}

            error={errors.categoryId}

            value={watch("categoryId")}

            setValue={(val) => {
              console.log("Category selection - val:", val);
              console.log("Current categoryId:", watch("categoryId"));
              console.log("Current subCategory:", watch("subCategory"));
              setValue("categoryId", val);
              setValue("subCategory", "");
              setValue("itemInfo", {});
            }}

          />

        ) : (

          <Input

            name="categoryId"

            title="Category"

            value={

              allCategory?.find((c: any) => c.id === watch("categoryId"))

                ?.category ||

              watch("categoryId") ||

              ""

            }

            disabled

            inputClassName={`px-4 py-2 text-sm w-full rounded-full ${isEditing ? "bg-white border border-[#D8D8D8]" : "bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"}`}

          />

        )}



        {/* 2. Sub Category */}

        {isEditing ? (

          <SelectInput

            name="subCategory"

            label="Sub Category"

            placeholder={

              !selectedCategory

                ? "Select Category first"

                : "Select Sub Category"

            }

            selectOptions={

              subCategories?.map((item: any) => ({

                id: item.id,

                value: item.id,

                text: item.subCategory,

              })) || []

            }

            register={register}

            clearErrors={clearErrors}

            validation={{ required: "Sub Category is required" }}

            error={errors.subCategory}

            value={watch("subCategory")}

            setValue={(val) => {
              console.log("SubCategory selection - val:", val);
              console.log("Current categoryId:", watch("categoryId"));
              console.log("Current subCategory:", watch("subCategory"));
              setValue("subCategory", val);
              setValue("itemInfo", {});
            }}

            disabled={!selectedCategory}

          />

        ) : (

          <Input

            name="subCategory"

            title="Sub Category"

            value={

              subCategories?.find((c: any) => c.id === watch("subCategory"))

                ?.subCategory ||

              watch("subCategory") ||

              ""

            }

            disabled

            inputClassName={`px-4 py-2 text-sm w-full rounded-full ${isEditing ? "bg-white border border-[#D8D8D8]" : "bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"}`}

          />

        )}



        {/* 3. Product Name */}

        <Input

          name="itemName"

          title="Product Name"

          register={register}

          validation={{
            required: "Item Name is required",
            pattern: {
              value: /^[a-zA-Z0-9\s\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\-_./()]+$/,
              message: "Product Name should not contain special characters",
            },
          }}

          other={{
            onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => {
              if (!/[a-zA-Z0-9\s\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\-_./()]/.test(e.key)) {
                e.preventDefault();
              }
            },
          }}

          error={errors.itemName}

          inputClassName={`px-4 py-2 text-sm w-full rounded-full ${isEditing ? "bg-white border border-[#D8D8D8]" : "bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"}`}

          disabled={!isEditing}

        />



        {/* 4. SKU (Always kept in the 4th column of the first row) */}

        <Input

          name="sku"

          title="SKU"

          register={register}

          validation={{

            required: "SKU is required",

            validate: (value: string) => {

              if (!value) return true;

              // Check if SKU starts with a special character (not alphanumeric or underscore)

              const firstChar = value.charAt(0);

              if (!/^[a-zA-Z0-9_]/.test(firstChar)) {

                return "SKU cannot start with special characters";

              }

              return true;

            }

          }}

          error={errors.sku}

          inputClassName={`px-4 py-2 text-sm w-full rounded-full ${isEditing ? "bg-white border border-[#D8D8D8]" : "bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"}`}

          disabled={!isEditing}

        />



        {/* 5. Dynamic Fields (Automatically flow into next rows but stay in the same grid) */}

        {selectedSubCategory &&

          dynamicFields

            .filter((fieldKey: string) => {

              const variants = watch("variants") || [];

              const isFieldInVariants = variants.some(

                (v: any) => v.name?.toLowerCase() === fieldKey?.toLowerCase(),

              );

              return !isFieldInVariants;

            })

            .map((field: any, idx: any) => (

              <Input

                key={field || idx}

                name={field}

                title={formatTitle(field)}

                placeholder={`Enter ${formatTitle(field)}`}

                register={register}

                validation={{ required: `${formatTitle(field)} is required` }}

                error={errors[field as keyof ItemForm]}

                inputClassName={`px-4 py-2 text-sm w-full rounded-full ${isEditing

                  ? "bg-white border border-[#D8D8D8]"

                  : "bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"

                  }`}

                disabled={!isEditing}

              />

            ))}



        {/* {watch("expiryBlock") && (

          <Input

            name="expiryDays"

            title="Expiry Days"

            type="number"

            register={register}

            validation={{ required: "Expiry Days is required" }}

            error={errors.expiryDays}

            inputClassName={`px-4 py-2 text-sm w-full rounded-full ${isEditing ? "bg-white border border-[#D8D8D8]" : "bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"}`}

            disabled={!isEditing}

          />

        )} */}



        <div className="col-span-full mt-4 pt-4 border-t border-dashed border-gray-200">

          <Controller

            name="tags"

            control={control}

            render={({ field }) => (

              <TagInput

                tags={field.value || []}

                onChange={field.onChange}

                isEditing={isEditing}

              />

            )}

          />

        </div>

      </div>

    </div>

  );

};



interface VariantImageFieldProps {

  index: number;

  control: any;

  isEditing: boolean;

  clearErrors: (name?: string | string[]) => void;

  value: File | string | null | undefined;

}



const VariantImageField: React.FC<VariantImageFieldProps> = ({

  index,

  control,

  isEditing,

  clearErrors,

  value,

}) => {

  const [preview, setPreview] = useState<string | null>(null);



  useEffect(() => {

    // 1. If no value, reset preview to null (shows cloud icon)

    if (!value) {

      setPreview(null);

      return;

    }



    // 2. If existing URL from backend

    if (typeof value === "string") {

      setPreview(value);

    }

    // 3. If new file selected from local machine

    else if (value instanceof File) {

      const objectUrl = URL.createObjectURL(value);

      setPreview(objectUrl);

      return () => URL.revokeObjectURL(objectUrl);

    }

  }, [value]);



  return (

    <Controller

      control={control}

      name={`variants.${index}.image`}

      render={({ field: { onChange }, fieldState }) => (

        <div className="relative group w-16 h-20 shrink-0">

          <input

            type="file"

            id={`upload-${index}`}

            className="hidden"

            disabled={!isEditing}

            accept="image/*"

            onChange={(e) => {

              const file = e.target.files?.[0];

              if (file) {

                onChange(file);

                clearErrors(`variants.${index}.image`);

              }

            }}

          />



          {/* Container Box */}

          <label

            htmlFor={`upload-${index}`}

            className={`flex items-center justify-center w-full h-full rounded-xl overflow-hidden border-2 border-dashed transition-all relative cursor-pointer

              ${fieldState.error ? "border-red-500 bg-red-50" : "border-gray-200 bg-[#FFFDF5] hover:border-amber-400"}

              ${!isEditing && "cursor-not-allowed opacity-80"}`}

          >

            {preview ? (

              <img

                src={preview}

                alt="Variant"

                className="w-full h-full object-cover"

                onError={() => setPreview(null)}

              />

            ) : (

              <div className="flex flex-col items-center justify-center p-2">

                <IconCloudUpload

                  size={28}

                  className="text-amber-500 opacity-80 group-hover:opacity-100 transition-opacity"

                />

              </div>

            )}



            {isEditing && preview && (

              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">

                <IconCloudUpload size={20} className="text-white" />

              </div>

            )}

          </label>



          {isEditing && value && (

            <button

              type="button"

              onClick={(e) => {

                e.preventDefault();

                onChange(null);

              }}

              className="absolute -top-2 -right-2 bg-white text-red-500 rounded-full shadow-md border border-gray-100 hover:bg-red-50 p-0.5 z-10 transition-transform hover:scale-110"

            >

              <IconX size={14} />

            </button>

          )}

        </div>

      )}

    />

  );

};



type VariantsSectionProps = {

  watch: UseFormWatch<ItemForm>;

  isEditing: boolean;

  control: Control<ItemForm>;

  register: UseFormRegister<ItemForm>;

  errors: FieldErrors<ItemForm>;

  clearErrors: UseFormClearErrors<ItemForm>;

  setSelectedDocument?: React.Dispatch<React.SetStateAction<any>>;

  setValue: UseFormSetValue<ItemForm>;

  mode?: string;

};



const VariantsSection: React.FC<VariantsSectionProps> = ({

  isEditing,

  control,

  register,

  clearErrors,

  watch,

  setValue,

  mode,

}) => {

  const { fields, append, remove } = useFieldArray<ItemForm>({

    control: control as any,

    name: "variants",

  });



  const watchedVariants = watch("variants");



  return (

    <div className="space-y-4">

      <div className="flex items-center justify-between border-b border-[#FBD037]/30 pb-2 mb-3 select-none">

        <div className="flex items-center gap-2">
          <p className="text-[#212121]/80 uppercase text-sm font-semibold tracking-wide">
            Configure Attribute Variants Matrix
          </p>
        </div>

        {isEditing && (

          <button

            type="button"

            onClick={() =>

              append({

                name: "",

                optionValue: "",

                price: "",

                sku: "",

                image: null,

              })

            }

            className="flex items-center gap-1 text-xs bg-[#FBD037] p-1.5 rounded-lg font-bold shadow-sm hover:scale-105 transition-transform"

          >

            <IconPlus size={16} />

          </button>

        )}

      </div>

      <div className="space-y-4">

        {fields.map((field: any, index) => (

          <div

            key={field.id}

            className="grid grid-cols-8 gap-3 items-center rounded-xl border border-gray-100"

          >

            <div className="col-span-2 flex items-center gap-2">

              <VariantImageField

                index={index}

                control={control}

                isEditing={isEditing}

                clearErrors={clearErrors as any}

                value={watchedVariants[index]?.image || null}

              />

              <div className="flex-1">

                <Input

                  name={`variants.${index}.sku`}

                  title="SKU"

                  register={register}

                  validation={{

                    validate: (value: string) => {

                      if (!value) return true;

                      // Check if SKU starts with a special character (not alphanumeric or underscore)

                      const firstChar = value.charAt(0);

                      if (!/^[a-zA-Z0-9_]/.test(firstChar)) {

                        return "SKU cannot start with special characters";

                      }

                      return true;

                    }

                  }}

                  disabled={!isEditing}

                  inputClassName={`px-4 py-2 text-sm w-full rounded-full ${isEditing ? "bg-yellow-50 border border-slate-200" : "bg-yellow-50/60 border border-slate-200 text-gray-500 cursor-not-allowed"}`}

                />

              </div>

            </div>



            <div className="col-span-2">

              <Input

                name={`variants.${index}.name`}

                title="Name"

                register={register}

                disabled={!isEditing}

                inputClassName={`px-4 py-2 text-sm w-full rounded-full ${isEditing ? "bg-yellow-50 border border-slate-200" : "bg-yellow-50/60 border border-slate-200 text-gray-500 cursor-not-allowed"}`}

              />

            </div>

            <div className="col-span-2">

              <Input

                name={`variants.${index}.optionValue`}

                title="Value"

                register={register}

                disabled={!isEditing}

                inputClassName={`px-4 py-2 text-sm w-full rounded-full ${isEditing ? "bg-yellow-50 border border-slate-200" : "bg-yellow-50/60 border border-slate-200 text-gray-500 cursor-not-allowed"}`}

              />

            </div>

            <div className="col-span-2 flex items-center gap-2">

              <div className="flex-1">

                <Input

                  name={`variants.${index}.price`}

                  title="Price"

                  type="number"

                  register={register}

                  disabled={!isEditing}

                  inputClassName={`px-4 py-2 text-sm w-full rounded-full ${isEditing ? "bg-yellow-50" : "bg-yellow-50 text-gray-500 cursor-not-allowed"}`}

                />

              </div>

              <div className="flex justify-center mt-5 shrink-0 gap-2">

                {((mode === "create" && fields?.length > 1) ||

                  (mode === "edit" &&

                    !watch(`variants.${index}.image`) &&

                    !watch(`variants.${index}.sku`))) && (

                    <button

                      type="button"

                      onClick={() => remove(index)}

                      className="flex items-center gap-1 text-xs bg-red-500/20 text-red-500 p-2 rounded-full font-bold shadow-sm hover:scale-105 transition-transform disabled:opacity-50 disabled:cursor-not-allowed"

                    >

                      <IconTrash size={18} />

                    </button>

                  )}



                {mode === "edit" &&

                  (watch(`variants.${index}.image`) ||

                    watch(`variants.${index}.sku`)) && (

                    <ToggleButton

                      size="sm"

                      onChange={(e) =>

                        setValue(

                          `variants.${index}.status`,

                          e?.target.checked ? "ACTIVE" : "INACTIVE",

                        )

                      }

                      disabled={!isEditing}

                      checked={watch(`variants.${index}.status`) === "ACTIVE"}

                    />

                  )}

              </div>

            </div>

          </div>

        ))}

      </div>

    </div>

  );

};



type StorageSectionProps = {

  isEditing: boolean;

  storageTypes: any[];

  register: UseFormRegister<ItemForm>;

  clearErrors: UseFormClearErrors<ItemForm>;

  errors: FieldErrors<ItemForm>;

  watch: UseFormWatch<ItemForm>;

  setValue: UseFormSetValue<ItemForm>;

  control: Control<ItemForm>;

  inline?: boolean;

};



const StorageSection: React.FC<StorageSectionProps> = ({

  isEditing,

  storageTypes,

  register,

  clearErrors,

  errors,

  watch,

  setValue,

  control, // ← add this prop

  inline = false,

}) => {

  const { fields, append, remove } = useFieldArray({
    control,
    name: "storage",
  });

  const storageValues = useWatch({
    control,
    name: "storage",
  });

  // Get available storage types for current index (filter out already selected types)
  const getAvailableStorageTypes = (currentIndex: number) => {
    const existingTypes = (storageValues || [])
      .map((field: any, index: number) => index !== currentIndex ? field?.type : null)
      .filter((type: any) => type && type !== "");
    return storageTypes.filter(type => !existingTypes.includes(type.value));
  };



  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between mb-2">
        <p className="text-[#212121]/80 uppercase text-xs font-bold tracking-wider">STORAGE</p>
        <button
          type="button"
          onClick={() => append({ type: "", capacity: "", minimumQuantity: "" })}
          disabled={!isEditing || fields.length >= 2}
          className="flex items-center gap-1 text-xs bg-[#FBD037] text-[#212121] p-1.5 rounded-lg font-bold shadow-sm hover:shadow-md hover:scale-105 transition-transform disabled:opacity-50 disabled:cursor-not-allowed"
          title={fields.length >= 2 ? "Maximum 2 storage entries allowed" : "Add storage entry"}
        >
          <IconPlus size={16} />
        </button>
      </div>

      <div className="space-y-2">
        {fields.length === 0 ? (
          <div className="text-center py-4 text-gray-500 text-sm">No storage configurations added yet</div>
        ) : (
          fields.map((field, index) => (
            <div key={field.id} className="grid grid-cols-1 sm:grid-cols-3 gap-4 relative items-end p-4 rounded-2xl border border-gray-100">
              {isEditing ? (
                <NewSelectInput
                  className="col-span-1"
                  name={`storage.${index}.type`}
                  label="Storage Type"
                  placeholder=""
                  selectOptions={getAvailableStorageTypes(index)}
                  clearErrors={clearErrors}
                  register={register}
                  validation={{ required: "Storage type is required" }}
                  error={errors?.storage?.[index]?.type}
                  value={storageValues?.[index]?.type || ""}
                  setValue={(val) => setValue(`storage.${index}.type`, val)}
                  disabled={!isEditing}
                />
              ) : (
                <NewinputField
                  className="col-span-1"
                  name={`storage.${index}.type`}
                  title="Storage Type"
                  value={storageValues?.[index]?.type || ""}
                  disabled
                  inputClassName="px-4 py-2.5 text-sm w-full rounded-xl bg-yellow-50 border border-slate-200 text-gray-500 cursor-not-allowed"
                />
              )}

              <NewinputField
                className="col-span-1"
                name={`storage.${index}.capacity`}
                type="number"
                title="Capacity"
                register={register}
                error={errors?.storage?.[index]?.capacity}
                validation={{ required: "Capacity is required", pattern: { value: /^[0-9]*$/, message: "Capacity must be a number" } }}
                inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
                disabled={!isEditing}
              />

              <div className="flex items-end gap-2">
                <div className="flex-1">
                  <NewinputField
                    className="col-span-1"
                    name={`storage.${index}.minimumQuantity`}
                    type="number"
                    title="Minimum Quantity"
                    register={register}
                    error={errors?.storage?.[index]?.minimumQuantity}
                    validation={{ required: "Minimum Quantity is required" }}
                    inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
                    disabled={!isEditing}
                  />
                </div>
                {isEditing && fields.length > 1 && (
                  <button
                    type="button"
                    onClick={() => remove(index)}
                    className="flex items-center gap-1 text-xs bg-red-500/20 text-red-500 p-2 rounded-lg font-bold shadow-sm hover:scale-105 transition-transform"
                    title="Remove this storage entry"
                  >
                    <IconTrash size={18} />
                  </button>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};



type DimensionsSectionProps = {

  isEditing: boolean;

  register: UseFormRegister<ItemForm>;

  errors: FieldErrors<ItemForm>;

  inline?: boolean;

};



const DimensionsSection: React.FC<DimensionsSectionProps> = ({

  isEditing,

  register,

  errors,

  inline = false,

}) => (

  <div className="space-y-3">
    <div className="mb-2">
      <p className="text-[#212121]/80 uppercase text-xs font-bold tracking-wider">DIMENSIONS & WEIGHT</p>
    </div>

    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      <NewinputField
        className=""
        name="length"
        type="number"
        title="Length"
        register={register}
        error={errors.length}
        validation={{ required: "Length is required", min: { value: 0.01, message: "Length must be greater than 0" } }}
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
        disabled={!isEditing}
      />
      <NewinputField
        className=""
        name="width"
        type="number"
        title="Width"
        register={register}
        error={errors.width}
        validation={{ required: "Width is required", min: { value: 0.01, message: "Width must be greater than 0" } }}
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
        disabled={!isEditing}
      />
      <NewinputField
        className=""
        name="height"
        type="number"
        title="Height"
        register={register}
        error={errors.height}
        validation={{ required: "Height is required", min: { value: 0.01, message: "Height must be greater than 0" } }}
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
        disabled={!isEditing}
      />
      <NewinputField
        className=""
        name="weight"
        type="number"
        title="Weight"
        register={register}
        error={errors.weight}
        validation={{ required: "Weight is required", min: { value: 0.01, message: "Weight must be greater than 0" } }}
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
        disabled={!isEditing}
      />
    </div>
  </div>
);



type PricingSectionProps = {

  isEditing: boolean;

  register: UseFormRegister<ItemForm>;

  errors: FieldErrors<ItemForm>;

  inline?: boolean;

};



const PricingSection: React.FC<PricingSectionProps> = ({

  isEditing,

  register,

  errors,

  inline = false,

}) => (

  <div className="group relative focus-within:z-50 rounded-2xl bg-gradient-to-b from-white/90 to-white/60 border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
    <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
      <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
        <IconTag size={16} className="text-[#212121]" stroke={1.5} />
      </div>
      <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">PRICING & COPYWRITING DETAILS</p>
    </div>
    <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      <NewinputField
        className=""
        name="price1"
        type="number"
        title="Price"
        register={register}
        error={errors.price1}
        validation={{ required: "Price is required", min: { value: 0.01, message: "Price must be greater than 0" } }}
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
        disabled={!isEditing}
      />
      <NewinputField
        className=""
        name="price2"
        type="number"
        title="Cost Price"
        register={register}
        error={errors.price2}
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
        disabled={!isEditing}
      />
      <NewinputField
        className=""
        name="discount"
        type="number"
        title="Discount"
        register={register}
        error={errors.discount}
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
        disabled={!isEditing}
      />
      <NewinputField
        className=""
        name="minimumOrder"
        type="number"
        title="Min Order"
        register={register}
        error={errors.minimumOrder}
        validation={{ required: "Minimum Order is required", min: { value: 1, message: "Minimum Order must be at least 1" } }}
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
        disabled={!isEditing}
      />
    </div>
  </div>
);



type ComplianceSectionProps = {

  isEditing: boolean;

  dangerousGoods: any[];

  register: UseFormRegister<ItemForm>;

  clearErrors: UseFormClearErrors<ItemForm>;

  errors: FieldErrors<ItemForm>;

  watch: UseFormWatch<ItemForm>;

  setValue: UseFormSetValue<ItemForm>;

  inline?: boolean;

};



const ComplianceSection: React.FC<ComplianceSectionProps> = ({

  isEditing,

  dangerousGoods,

  register,

  clearErrors,

  errors,

  watch,

  setValue,

  inline = false,

}) => (

  <div className="space-y-3">
    <div className="mb-2">
      <p className="text-[#212121]/80 uppercase text-xs font-bold tracking-wider">COMPLIANCE & CODES</p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

      <NewinputField
        className=""
        name="commodity"
        type="text"
        title="Commodity"
        register={register}
        error={errors.commodity}
        validation={{ required: "Commodity is required" }}
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50/60 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
        disabled={!isEditing}
      />

      <NewinputField
        className=""
        name="importCommodity"
        type="text"
        title="Import Commodity"
        register={register}
        error={errors.importCommodity}
        validation={{ required: "Import Commodity is required" }}
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50/60 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
        disabled={!isEditing}
      />

      <NewinputField
        className=""
        name="hsCode"
        type="text"
        title="HS Code"
        register={register}
        error={errors.hsCode}
        validation={{
          required: "HS Code is required",
          pattern: {
            value: /^[0-9]+$/,
            message: "HS Code must be numbers only",
          },
        }}
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50/60 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
        disabled={!isEditing}
        other={{
          maxLength: 12,
          onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => {
            if (!/[0-9]/.test(e.key)) {
              e.preventDefault();
            }
          },
        }}
      />

    </div>

  </div>

);



type DescriptionsSectionProps = {

  isEditing: boolean;

  register: UseFormRegister<ItemForm>;

  errors: FieldErrors<ItemForm>;

  inline?: boolean;

};



const DescriptionsSection: React.FC<DescriptionsSectionProps> = ({

  isEditing,

  register,

  errors,

  inline = false,

}) => (

  <div className="space-y-3">
    <div className="mb-2">
      <p className="text-[#212121]/80 uppercase text-xs font-bold tracking-wider">DESCRIPTIONS</p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <TextareaField
        label="General Description"
        name="shortDescription"
        register={register}
        validation={{ required: "General Description is required" }}
        error={errors.shortDescription}
        disabled={!isEditing}
        placeholder=""
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl outline-none resize-none ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 transition-all" : "bg-yellow-50/60 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
      />
      <TextareaField
        label="SKU Description"
        name="longDescription"
        register={register}
        validation={{ required: "SKU Description is required" }}
        error={errors.longDescription}
        disabled={!isEditing}
        placeholder=""
        inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl outline-none resize-none ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 transition-all" : "bg-yellow-50/60 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
      />
    </div>
  </div>
);



interface AddItemProps {
  itemId?: string;
  onClose?: () => void;
  onSuccess?: () => void;
  inline?: boolean;
  defaultEditing?: boolean;
  hideHeader?: boolean;
}

const AddItem = forwardRef<{ submit: () => void }, AddItemProps>(
  (
    {
      itemId,
      onClose,
      onSuccess,
      inline = false,
      defaultEditing = false,
      hideHeader = false,
    },
    ref,
  ) => {
    const navigate = useNavigate();
    const { id: paramId } = useParams();
  const id = itemId || paramId;



  const { data: product, refetch: fetchData } =

    useFetchProductItemsViewData(id);

  const { data: allCategory } = useProductCategoryAllListData();


  const [isEditing, setIsEditing] = useState(!id || defaultEditing);

  const [localMedia, setLocalMedia] = useState<FileWithPreview[]>([]);

  const [showVariantWarning, setShowVariantWarning] = useState(false);

  const [termsEnabled, setTermsEnabled] = useState(false);



  const {

    register,

    handleSubmit,

    watch,

    setValue,

    clearErrors,

    control,

    formState: { errors },

  } = useForm<ItemForm>({

    defaultValues: {

      itemName: "",

      categoryId: "",

      subCategory: "",

      // storageType: "",

      storage: [

        { type: "", capacity: "", minimumQuantity: "" },

      ],

      sku: "",

      // capacity: "",

      // minimumQuantity: "",

      length: null,

      width: null,

      height: null,

      weight: 0,

      commodity: "",

      importCommodity: "",

      dangerousGoods: false,

      hsCode: "",

      shortDescription: "",

      longDescription: "",

      termsAndConditions: "",

      itemInfo: {},

      variants: [

        {

          name: "",

          optionValue: "",

          price: "",

          sku: "",

          image: File ? (null as any) : null,

        },

      ],

      configOptions: [],

      publishedOnApp: false,

    },

  });



  const selectedCategory = watch("categoryId");

  const selectedSubCategory = watch("subCategory");

  const { data: subCategories } = useProductSubCategoriesListData(

    selectedCategory || "",

  );
  const configOptions = watch("configOptions") || [];

  // const showVariants = configOptions.includes("productVariants");



  const { mutate: createItem, isPending: creating } =

    useItemProductCreateMutation();

  const { mutate: updateItem, isPending: updating } = useItemsUpdateMutation(

    id || "",

  );



  useEffect(() => {

    if (product) {

      setValue("categoryId", product.categoryName || product.categoryId || "");

      // setValue("subCategory", product.categoryDetails?.subCategory || product.subCategory || "");

      // setValue("storageType", product.storageType || "");

      setValue("dangerousGoods", product.dangerousGoods === "true" || product.dangerousGoods === true);

      setValue("itemName", product.itemName || "");

      // setValue("capacity", product.capacity || "");

      // setValue("minimumQuantity", product.minimumQuantity || "");

      setValue("length", product.length ?? null);

      setValue("width", product.width ?? null);

      setValue("height", product.height ?? null);

      setValue("weight", product.weight || 0);

      setValue("commodity", product.commodity || "");

      setValue("importCommodity", product.importCommodity || "");

      setValue("hsCode", product.hsCode || "");

      setValue("shortDescription", product.shortDescription || "");

      setValue("longDescription", product.longDescription || "");

      setValue("termsAndConditions", product.termsAndConditions || "");
      setTermsEnabled(Boolean(product.termsAndConditions));

      setValue("expiryBlock", product.hasExpiry ? true : false);

      setValue("expiryDays", product.expiryDays ?? null);

      setValue("price1", product.price1 || "");

      setValue("price2", product.price2 || "");

      setValue("discount", product.discount || "");

      setValue("minimumOrder", product.minimumOrder || "");

      setValue("sku", product.sku || "");

      setValue("publishedOnApp", product.publishedOnApp || false);

      setValue("variantsEnabled", product.variants?.length > 0 ? true : false);

      setValue("tags", product.tags || []);

      setValue(

        "variants",

        product.variants?.length > 0

          ? product.variants?.map((v: any) => ({

            name: v.optionName || "",

            optionValue: v.optionValue || "",

            price: v.price || "",

            sku: v.sku || "",

            image: v?.image, // We'll handle images separately

            existingImage: v.image || null, // Store existing image URL if present,

            status: v.status || "ACTIVE", // Default to ACTIVE if not provided

          }))

          : [

            {

              name: "",

              optionValue: "",

              price: "",

              sku: "",

              image: File ? (null as any) : null,

              status: "ACTIVE",

            },

          ],

      );

      setValue(

        "storage",

        (() => {
          let storageArray: any[] = [];
          if (product.storage) {
            if (Array.isArray(product.storage) && product.storage.length > 0) {
              storageArray = product.storage.map((s: any) => ({
                type: s.type || s.storageType || "",
                capacity: s.capacity || "",
                minimumQuantity: s.minimumQuantity || "",
              }));
            } else if ((typeof product.storage === "object" || typeof product.storage === "string") && !Array.isArray(product.storage)) {
              let storageObj = typeof product.storage === "string" ? JSON.parse(product.storage) : product.storage;
              storageArray = [{
                type: storageObj.type || storageObj.storageType || "",
                capacity: storageObj.capacity || "",
                minimumQuantity: storageObj.minimumQuantity || "",
              }];
            }
          }
          return storageArray;
        })(),

      );

      setValue("configOptions", product.configOptions || []);



      const allMediaUrls: string[] =

        product.images && product?.images?.length > 0

          ? product.images

          : product.image

            ? [product.image]

            : [];



      const videoExtensions = [".mp4", ".webm", ".mov", ".ogg"];



      const foundVideoUrl = allMediaUrls.find((url: string) => {

        const cleanUrl = url?.split("?")[0]?.toLowerCase();

        return videoExtensions?.some((ext) => cleanUrl?.endsWith(ext));

      });



      const mediaItems: FileWithPreview[] = [];



      if (foundVideoUrl) {

        mediaItems.push({

          file: foundVideoUrl,

          preview: foundVideoUrl,

          isExisting: true,

          type: "video",

        });

      } else if (product.video) {

        mediaItems.push({

          file: product.video,

          preview: product.video,

          isExisting: true,

          type: "video",

        });

      }



      allMediaUrls

        .filter((url: string) => url !== foundVideoUrl && url !== product.video)

        .forEach((url: string) => {

          mediaItems.push({

            file: url,

            preview: url,

            isExisting: true,

            type: "image",

          });

        });



      setLocalMedia(mediaItems);



      mediaItems.forEach((item, idx) => {

        if (

          item.type === "video" &&

          typeof item.file === "string" &&

          !item.thumbnail

        ) {

          generateVideoThumbnail(item.file).then((thumbnail) => {

            setLocalMedia((prev) => {

              const newPrev = [...prev];

              newPrev[idx] = { ...newPrev[idx], thumbnail };

              return newPrev;

            });

          });

        }

      });

    }

  }, [product, setValue]);



  useEffect(() => {
    fetchData();
    document.title = id ? "Edit Item | TrackTechs" : "Add New Item | TrackTechs";
  }, [id]);



  useEffect(() => {

    const targetSub =

      product?.categoryDetails?.subCategory || product?.subCategory;



    if (targetSub && subCategories?.length > 0) {

      // Optional: Check if the value exists in the fetched list to avoid UI glitches

      const exists = subCategories.find(

        (s: any) => s.id === targetSub || s.subCategory === targetSub,

      );



      if (exists) {

        setValue("subCategory", exists.id);



        if (product.itemInfo) {

          Object.entries(product.itemInfo).forEach(([key, value]) => {

            setValue(key as any, value);

          });

        }

      }

    }

  }, [product, subCategories, setValue]);



  const onSubmit = (values: any) => {

    console.log("=== onSubmit called ===");

    console.log("Form values:", values);

    console.log("categoryId:", values.categoryId);

    console.log("subCategory:", values.subCategory);

    console.log("subCategories array:", subCategories);

    const subCat = subCategories?.find(

      (sc: any) => sc.id === values.subCategory,

    );

    console.log("Found subCat:", subCat);

    const dynamicFields: Record<string, any> = {};

    subCat?.fields?.forEach(

      (field: any) => (dynamicFields[field] = values[field] || ""),

    );

    Object.entries(values.itemInfo || {}).forEach(([key, value]) => {

      dynamicFields[key] = value;

    });

    const newFiles = localMedia

      .filter((item) => item.file instanceof File)

      .map((item) => item.file);



    const existingPaths = localMedia

      .filter((item) => typeof item.file === "string")

      .map((item) => {

        if (typeof item.file === "string") {

          try {
            if (item.file.startsWith("http://") || item.file.startsWith("https://")) {
              const urlObj = new URL(item.file);
              const pathname = urlObj.pathname;
              return pathname.startsWith("/") ? pathname.slice(1) : pathname;
            }
          } catch (e) {
            console.error("Failed to parse URL:", item.file, e);
          }

          return item.file.split("?")[0].split(".com/")[1] || "";

        }

        return "";

      });



    const newImages = newFiles.filter(

      (f) => f instanceof File && !f.type.startsWith("video/"),

    );

    const newVideo =

      newFiles.find((f) => f instanceof File && f.type.startsWith("video/")) ||

      null;



    const videoExtensions = [".mp4", ".webm", ".mov", ".ogg"];



    const remainingImages = existingPaths.filter((path) => {

      const lower = path.toLowerCase();

      return !videoExtensions.some((ext) => lower.endsWith(ext));

    });



    const remainingVideo =

      existingPaths.find((path) => {

        const lower = path.toLowerCase();

        return videoExtensions.some((ext) => lower.endsWith(ext));

      }) || null;



    // Set primary image (New file takes priority over existing)

    const primaryImage =

      newImages.length > 0 ? newImages[0] : remainingImages[0] || undefined;



    const processedVariants = (values.variants || [])

      .filter(

        (v: any) => v.name?.trim() || v.optionValue?.trim() || v.price || v.sku,

      )

      .map((v: any) => {

        const variantCopy = { ...v };

        if (typeof variantCopy.image === "string") {

          delete variantCopy.image;

          variantCopy.isExistingImage = true;

        } else if (variantCopy.image instanceof File) {

          variantCopy.isExistingImage = false;

        }



        return variantCopy;

      });



    const payload = {

      itemName: values.itemName,

      categoryId:

        allCategory?.find((c: any) => c.category === values.categoryId)?.id ||

        values.categoryId,

      subCategory: values.subCategory,

      storage: values.storage.map((s: any) => ({
        type: s.type,
        capacity: s.capacity,
        minimumQuantity: Number(s.minimumQuantity) || 0,
      })),

      length: values.length !== null ? Number(values.length) : null,

      width: values.width !== null ? Number(values.width) : null,

      height: values.height !== null ? Number(values.height) : null,

      weight: Number(values.weight),

      commodity: values.commodity,

      importCommodity: values.importCommodity,

      dangerousGoods: values.dangerousGoods,

      hsCode: values.hsCode,

      shortDescription: values.shortDescription,

      longDescription: values.longDescription,

      termsAndConditions: values.termsAndConditions,

      sku: values.sku,

      itemInfo: dynamicFields,

      tags: values.tags || [],

      price1: values.price1,

      price2: values.price2,

      discount: values.discount,

      minimumOrder: values.minimumOrder,



      // Media

      images: newImages, // Binary files

      remainingImages: JSON.stringify(remainingImages), // String paths

      video: newVideo, // Binary file

      remainingVideo: remainingVideo, // String path

      image: primaryImage, // Binary or String



      hasExpiry: values.expiryBlock || false,

      expiryDays: values.expiryDays ? Number(values.expiryDays) : null,



      // Variants

      variants: processedVariants,



      configOptions: values.configOptions,

      publishedOnApp: values.publishedOnApp,

    };

    console.log("=== Final Payload ===");
    console.log("Payload categoryId:", payload.categoryId);
    console.log("Payload subCategory:", payload.subCategory);
    console.log("Full payload:", payload);

    // 5. Execute API Call

    if (id) {

      updateItem(payload, {

        onSuccess: () => {

          if (inline && onSuccess) {

            onSuccess();

          } else {

            navigate("/inventory-management");

          }

          toast.success("Item Updated Successfully.");

        },

        onError: (err) => toast.error("Failed to update item."),

      });

    } else {

      createItem(payload, {

        onSuccess: () => {

          if (inline && onSuccess) {

            onSuccess();

          } else {

            navigate("/inventory-management");

          }

          toast.success("Item Added Successfully.");

        },

        onError: (err) => toast.error("Failed to add item."),

      });

    }

  };



  const handleCancelEdit = () => {

    if (product) {

      // 1. Basic Info (Matched to useEffect)

      setValue("categoryId", product.categoryName || product.categoryId || "");

      // setValue("storageType", product.storageType || "");

      setValue("dangerousGoods", product.dangerousGoods === "true" || product.dangerousGoods === true);

      setValue("itemName", product.itemName || "");

      // setValue("capacity", product.capacity || "");

      // setValue("minimumQuantity", product.minimumQuantity || "");

      setValue(

        "storage",

        (() => {
          let storageArray: any[] = [];
          if (product.storage) {
            if (Array.isArray(product.storage) && product.storage.length > 0) {
              storageArray = product.storage.map((s: any) => ({
                type: s.type || s.storageType || "",
                capacity: s.capacity || "",
                minimumQuantity: s.minimumQuantity || "",
              }));
            } else if ((typeof product.storage === "object" || typeof product.storage === "string") && !Array.isArray(product.storage)) {
              let storageObj = typeof product.storage === "string" ? JSON.parse(product.storage) : product.storage;
              storageArray = [{
                type: storageObj.type || storageObj.storageType || "",
                capacity: storageObj.capacity || "",
                minimumQuantity: storageObj.minimumQuantity || "",
              }];
            }
          }
          return storageArray;
        })(),

      );

      setValue("length", product.length ?? null);

      setValue("width", product.width ?? null);

      setValue("height", product.height ?? null);

      setValue("weight", product.weight || 0);

      setValue("commodity", product.commodity || "");

      setValue("importCommodity", product.importCommodity || "");

      setValue("hsCode", product.hsCode || "");

      setValue("shortDescription", product.shortDescription || "");

      setValue("longDescription", product.longDescription || "");

      setValue("termsAndConditions", product.termsAndConditions || "");
      setTermsEnabled(Boolean(product.termsAndConditions));

      setValue("sku", product.sku || "");



      // 2. Missing Fields from your version

      setValue("expiryBlock", !!product.hasExpiry);

      setValue("expiryDays", product.expiryDays ?? null);

      setValue("price1", product.price1 || "");

      setValue("price2", product.price2 || "");

      setValue("discount", product.discount || "");

      setValue("minimumOrder", product.minimumOrder || "");

      setValue("publishedOnApp", product.publishedOnApp || false);

      setValue("variantsEnabled", product.variants?.length > 0);

      setValue("tags", product.tags || []);



      // 3. IMPORTANT: Variant Mapping (Must match useEffect)

      setValue(

        "variants",

        product.variants?.length > 0

          ? product.variants.map((v: any) => ({

            name: v.optionName || "",

            optionValue: v.optionValue || "",

            price: v.price || "",

            sku: v.sku || "",

            image: v?.image,

            existingImage: v.image || null,

            status: v.status || "ACTIVE",

          }))

          : [

            {

              name: "",

              optionValue: "",

              price: "",

              sku: "",

              image: null,

              status: "ACTIVE",

            },

          ],

      );



      setValue("configOptions", product.configOptions || []);



      const allMediaUrls: string[] =

        product.images || (product.image ? [product.image] : []);

      const videoExtensions = [".mp4", ".webm", ".mov", ".ogg"];

      const foundVideoUrl = allMediaUrls.find((url: string) => {

        const cleanUrl = url.split("?")[0].toLowerCase();

        return videoExtensions.some((ext) => cleanUrl.endsWith(ext));

      });



      const mediaItems: FileWithPreview[] = [];

      if (foundVideoUrl) {

        mediaItems.push({

          file: foundVideoUrl,

          preview: foundVideoUrl,

          isExisting: true,

          type: "video",

        });

      } else if (product.video) {

        mediaItems.push({

          file: product.video,

          preview: product.video,

          isExisting: true,

          type: "video",

        });

      }



      allMediaUrls

        .filter((url: string) => url !== foundVideoUrl && url !== product.video)

        .forEach((url: string) => {

          mediaItems.push({

            file: url,

            preview: url,

            isExisting: true,

            type: "image",

          });

        });



      setLocalMedia(mediaItems);



      // Trigger thumbnail generation if needed

      mediaItems.forEach((item, idx) => {

        if (

          item.type === "video" &&

          typeof item.file === "string" &&

          !item.thumbnail

        ) {

          generateVideoThumbnail(item.file).then((thumbnail) => {

            setLocalMedia((prev) => {

              const newPrev = [...prev];

              newPrev[idx] = { ...newPrev[idx], thumbnail };

              return newPrev;

            });

          });

        }

      });

    }



    setIsEditing(false);

  };

  // Expose submit method to parent
  useImperativeHandle(ref, () => ({
    submit: () => {
      handleSubmit(onSubmit)();
    },
  }));

  return (
    <>
      {/* Header Section with all buttons */}
      {!hideHeader && (
        <Header
          id={id}
          isEditing={isEditing}
          product={product}
          navigate={navigate}
          setIsEditing={setIsEditing}
          handleCancelEdit={handleCancelEdit}
          handleSubmit={handleSubmit(onSubmit)}
          creating={creating}
          updating={updating}
          inline={inline}
          onClose={onClose}
        />
      )}
      <div className="h-[calc(100vh-0rem)] overflow-y-auto p-4 scrollbar-clean">
        <div className={inline ? "grid grid-cols-12 gap-4 items-stretch" : "grid grid-cols-12 gap-4 items-start"}>

          {/* Column 1: Product Media */}
          <div className={inline ? "col-span-12" : "col-span-12 lg:col-span-6"}>
            <div className="space-y-3">
              <div className="mb-2">
                <p className="text-[#212121]/80 uppercase text-xs font-bold tracking-wider">PRODUCT MEDIA</p>
              </div>
              <MediaUploader
                media={localMedia}
                onMediaChange={setLocalMedia}
                isEditing={isEditing}
                inline={inline}
              />
            </div>
          </div>

          {/* Column 2: Basic Information */}
          <div className={inline ? "col-span-12 space-y-4 relative focus-within:z-50" : "col-span-12 lg:col-span-6 space-y-4 relative focus-within:z-50"}>
            {/* Basic Information Panel */}
            <div className="space-y-3">
              <div className="mb-2">
                <p className="text-[#212121]/80 uppercase text-xs font-bold tracking-wider">BASIC INFORMATION</p>
              </div>
              <div className="grid grid-cols-6 gap-4">
                <NewinputField
                  className="col-span-6 sm:col-span-3"
                  name="itemName"
                  title="Product Name"
                  register={register}
                  validation={{
                    required: "Item Name is required",
                    pattern: {
                      value: /^[a-zA-Z0-9\s\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\-_./()]+$/,
                      message: "Product Name should not contain special characters",
                    },
                  }}
                  error={errors.itemName}
                  inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50/60 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
                  disabled={!isEditing}
                />
                <NewinputField
                  className="col-span-6 sm:col-span-3"
                  name="sku"
                  title="SKU"
                  register={register}
                  validation={{
                    required: "SKU is required",
                    validate: (value: string) => {
                      if (!value) return true;
                      const firstChar = value.charAt(0);
                      if (!/^[a-zA-Z0-9_]/.test(firstChar)) {
                        return "SKU cannot start with special characters";
                      }
                      return true;
                    },
                  }}
                  error={errors.sku}
                  inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50/60 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
                  disabled={!isEditing}
                />
                {isEditing ? (
                  <NewSelectInput
                    className="col-span-6 sm:col-span-3"
                    name="categoryId"
                    label="Category"
                    placeholder="Select Category"
                    selectOptions={allCategory?.map((item: any) => ({ id: item.id, value: item.category, text: item.category })) || []}
                    register={register}
                    clearErrors={clearErrors}
                    validation={{ required: "Category is required" }}
                    error={errors.categoryId}
                    value={watch("categoryId")}
                    setValue={(val) => {
                      setValue("categoryId", val);
                      setValue("subCategory", "");
                      setValue("itemInfo", {});
                    }}
                  />
                ) : (
                  <NewinputField
                    className="col-span-6 sm:col-span-3"
                    name="categoryId"
                    title="Category"
                    value={allCategory?.find((c: any) => c.id === watch("categoryId"))?.category || watch("categoryId") || ""}
                    disabled
                    inputClassName="px-4 py-2.5 text-sm w-full rounded-xl bg-gray-50 border border-gray-200 text-gray-500 cursor-not-allowed"
                  />
                )}
                {isEditing ? (
                  <NewSelectInput
                    className="col-span-6 sm:col-span-3"
                    name="subCategory"
                    label="Sub Category"
                    placeholder={!selectedCategory ? "Category first" : "Sub Category"}
                    selectOptions={subCategories?.map((item: any) => ({ id: item.id, value: item.id, text: item.subCategory })) || []}
                    register={register}
                    clearErrors={clearErrors}
                    validation={{ required: "Sub Category is required" }}
                    error={errors.subCategory}
                    value={watch("subCategory")}
                    setValue={(val) => { setValue("subCategory", val); setValue("itemInfo", {}); }}
                    disabled={!selectedCategory}
                  />
                ) : (
                  <NewinputField
                    className="col-span-6 sm:col-span-3"
                    name="subCategory"
                    title="Sub Category"
                    value={subCategories?.find((c: any) => c.id === watch("subCategory"))?.subCategory || watch("subCategory") || ""}
                    disabled
                    inputClassName="px-4 py-2.5 text-sm w-full rounded-xl bg-gray-50 border border-gray-200 text-gray-500 cursor-not-allowed"
                  />
                )}

                {/* Subcategory Dynamic Fields */}
                {selectedSubCategory &&
                  (subCategories?.find((sc: any) => sc.id === selectedSubCategory)?.fields || [])
                    .filter((fieldKey: string) => {
                      const vars = watch("variants") || [];
                      return !vars.some((v: any) => v.name?.toLowerCase() === fieldKey?.toLowerCase());
                    })
                    .map((field: any, idx: any) => {
                      const rawTitle = field.replace(/([A-Z])/g, " $1").replace(/_/g, " ").trim().split(" ").map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
                      return (
                        <div key={field || idx} className="col-span-6 sm:col-span-3">
                          <NewinputField
                            className=""
                            name={field}
                            title={rawTitle}
                            placeholder={`Enter ${rawTitle}`}
                            register={register}
                            validation={{ required: `${rawTitle} is required` }}
                            error={errors[field as keyof ItemForm]}
                            inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50/60 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
                            disabled={!isEditing}
                          />
                        </div>
                      );
                    })}

                {/* Tags */}
                <div className="col-span-6">
                  <Controller
                    name="tags"
                    control={control}
                    render={({ field }) => (
                      <TagInput tags={field.value || []} onChange={field.onChange} isEditing={isEditing} />
                    )}
                  />
                </div>

                {/* Expiry Days conditional */}
                {watch("expiryBlock") && (
                  <div className="col-span-6 sm:col-span-3">
                    <NewinputField
                      className=""
                      name="expiryDays"
                      type="number"
                      title="Expiry Days"
                      register={register}
                      validation={{ required: "Expiry Days is required" }}
                      error={errors.expiryDays}
                      inputClassName={`px-4 py-2.5 text-sm w-full rounded-xl ${isEditing ? "bg-yellow-50 border border-[#FBD037] focus:border-amber-400 outline-none transition-all" : "bg-yellow-50/60 border border-[#FBD037] text-gray-500 cursor-not-allowed"}`}
                      disabled={!isEditing}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Storage Panel */}
            <StorageSection
              isEditing={isEditing}
              storageTypes={storageTypes}
              register={register}
              clearErrors={clearErrors}
              errors={errors}
              watch={watch}
              setValue={setValue}
              control={control}
              inline={inline}
            />
          </div>

          {/* Variants Section */}
          {watch("variantsEnabled") && (
            <div className="col-span-12">
              <VariantsSection
                watch={watch}
                isEditing={isEditing}
                control={control}
                register={register}
                errors={errors}
                clearErrors={clearErrors}
                setValue={setValue}
                mode={id ? "edit" : "create"}
              />
            </div>
          )}

          {/* Compliance Section */}
          <div className="col-span-12 relative focus-within:z-50">
            <ComplianceSection
              isEditing={isEditing}
              dangerousGoods={dangerousGoods}
              register={register}
              clearErrors={clearErrors}
              errors={errors}
              watch={watch}
              setValue={setValue}
              inline={inline}
            />
          </div>

          {/* Dimensions & Weight */}
          <div className="col-span-12 relative focus-within:z-50">
            <DimensionsSection
              isEditing={isEditing}
              register={register}
              errors={errors}
              inline={inline}
            />
          </div>

          {/* Pricing & Copywriting */}
          <div className="col-span-12 relative focus-within:z-50">
            <DescriptionsSection
              isEditing={isEditing}
              register={register}
              errors={errors}
              inline={inline}
            />
          </div>

          {/* Terms & Conditions */}
          {termsEnabled && (
            <div className="col-span-12">
              <div className="group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
                  <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">TERMS & CONDITIONS</p>
                </div>
                <TextareaField
                  label="Terms and Conditions"
                  name="termsAndConditions"
                  register={register}
                  disabled={!isEditing}
                />
              </div>
            </div>
          )}

          {/* Non-inline bottom action buttons */}
          {!inline && (
            <div className="col-span-12">
              {isEditing ? (
                <div className="flex flex-col gap-2 mt-2 border-t border-[#ECECEC] pt-4">
                  <button
                    type="button"
                    onClick={handleSubmit(onSubmit)}
                    disabled={creating || updating}
                    className="w-fit min-w-[280px] px-8 py-3 mx-auto rounded-full bg-[#FBD037] hover:bg-yellow-500 text-black font-semibold text-sm transition shadow-sm hover:shadow flex items-center justify-center gap-2"
                  >
                    {id ? "Update Item" : "Publish & Active Item"}
                  </button>
                  <button
                    type="button"
                    onClick={() => { if (id) { handleCancelEdit(); } else { navigate("/inventory-management"); } }}
                    className="w-full py-2.5 text-center text-xs text-gray-500 hover:text-red-500 transition font-medium"
                  >
                    Discard Changes
                  </button>
                </div>
              ) : (
                <div className="bg-amber-50/60 border border-[#FEF3C7] rounded-2xl p-4 text-center mt-2">
                  <p className="text-xs text-amber-800 font-medium">
                    Viewing in read-only mode. Click "Edit Item" at the top to make modifications.
                  </p>
                </div>
              )}
            </div>
          )}

        </div>
      </div>

      <ConfirmModal
        isOpen={showVariantWarning}
        onClose={() => setShowVariantWarning(false)}
        onConfirm={() => {
          setValue("variantsEnabled", false);
          setValue("variants", [
            {
              name: "",
              optionValue: "",
              price: "",
              sku: "",
              image: null,
              status: "ACTIVE",
            },
          ]);
        }}
        title="Clear Variant Data?"
        message="Turning off variants will delete all SKU, price, and image data you've entered for these options."
      />
    </>
  );
});

/* ORIGINAL CODE COMMENTED OUT FOR REFERENCE:
const AddItemOldCode = () => {
  return (
    <>
      <div className="max-w-[1400px] mx-auto p-6 space-y-6">
        <Header
          id={id}
          isEditing={isEditing}
          product={product}
          navigate={navigate}
          setIsEditing={setIsEditing}
          handleCancelEdit={handleCancelEdit}
          handleSubmit={handleSubmit(onSubmit)}
          creating={creating}
          updating={updating}
        />
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-3">
            <div className="shadow-sm rounded-full h-full">
              <MediaUploader
                media={localMedia}
                onMediaChange={setLocalMedia}
                isEditing={isEditing}
              />
            </div>
          </div>
          <div className="col-span-12 lg:col-span-9">
            <div className="shadow-sm rounded-full h-full">
              <IdentificationSection
                isEditing={isEditing}
                allCategory={allCategory}
                subCategories={subCategories}
                selectedCategory={selectedCategory}
                selectedSubCategory={selectedSubCategory}
                control={control}
                register={register}
                clearErrors={clearErrors}
                errors={errors}
                watch={watch}
                setValue={setValue}
                setShowVariantWarning={setShowVariantWarning}
              />
            </div>
          </div>
          {watch("variantsEnabled") && (
            <div className="col-span-12">
              <div className="shadow-sm rounded-full h-full">
                <VariantsSection
                  watch={watch}
                  isEditing={isEditing}
                  control={control}
                  register={register}
                  errors={errors}
                  clearErrors={clearErrors}
                  setValue={setValue}
                  mode={id ? "edit" : "create"}
                />
              </div>
            </div>
          )}
          <div className="col-span-12 lg:col-span-6 z-30">
            <div className="shadow-sm rounded-2xl h-full">
              <StorageSection
                isEditing={isEditing}
                storageTypes={storageTypes}
                register={register}
                clearErrors={clearErrors}
                errors={errors}
                watch={watch}
                setValue={setValue}
                control={control}
              />
            </div>
          </div>
          <div className="col-span-12 lg:col-span-6">
            <div className="rounded-2xl shadow-sm h-full">
              <ComplianceSection
                isEditing={isEditing}
                dangerousGoods={dangerousGoods}
                register={register}
                clearErrors={clearErrors}
                errors={errors}
                watch={watch}
                setValue={setValue}
              />
            </div>
          </div>
          <div className="col-span-12 lg:col-span-6 ">
            <div className="rounded-2xl shadow-sm">
              <DimensionsSection
                isEditing={isEditing}
                register={register}
                errors={errors}
              />
            </div>
          </div>
          <div className="col-span-12 lg:col-span-6">
            <div className="rounded-2xl shadow-sm">
              <PricingSection
                register={register}
                errors={errors}
                isEditing={isEditing}
              />
            </div>
          </div>
          <div className="col-span-12">
            <div className="rounded-2xl shadow-sm">
              <DescriptionsSection
                isEditing={isEditing}
                register={register}
                errors={errors}
              />
            </div>
          </div>
          {watch("termsAndConditions") && (
            <div className="border border-[#D2D2D2]/70 backdrop-blur-xl rounded-[20px] p-4 bg-gradient-to-r from-white/90 to-white/60 space-y-4  col-span-12">
              <h2>Term and Conditions</h2>
              <div className="rounded-2xl shadow-sm">
                <TextareaField
                  label="Term and Conditions"
                  name="termsAndConditions"
                  register={register}
                  disabled={!isEditing}
                  placeholder=""
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <ConfirmModal
        isOpen={showVariantWarning}
        onClose={() => setShowVariantWarning(false)}
        onConfirm={() => {
          setValue("variantsEnabled", false);
          setValue("variants", [
            {
              name: "",
              optionValue: "",
              price: "",
              sku: "",
              image: null,
              status: "ACTIVE",
            },
          ]);
        }}
        title="Clear Variant Data?"
        message="Turning off variants will delete all SKU, price, and image data you've entered for these options."
      />
    </>
  );
};
*/

export default AddItem;

